import React from "react";
import {connect} from "react-redux";
import PostList from "../Feed/PostFeed/PostList";
import {getLastContent} from "../../API/api-static";
import HeaderTitreSousTitre from "../Header/HeaderTitreSousTitre";
import {customFeed, getBookmark, getTrendingAll, searchPost} from "../../API/API";
import {Image, TouchableOpacity, Text, View} from "react-native";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import ConfidentialPicto from "../Picto/ConfidentialPicto";

class TendanceFeedScreen extends React.Component{

    constructor(props) {
        super(props);
        this.id = this.props.route.params.id;
        this.type = this.props.route.params.type;

        this.state = {
            isRefresh : false,
            posts : [],
            cursor:undefined,
            bookmark:[],
            currentTendance: undefined,
            name : ""
        }

        this._getPosts = this._getPosts.bind(this);
        this.getTendanceInfo = this.getTendanceInfo.bind(this);
        this.getTendanceInfo();
    }

    getTendanceInfo(){
        getTrendingAll(this.props.timeParution).then(data=>{
           const currentTendance = data[this.type].filter((item)=>item.id == this.id)[0];
           const name  = this.getName(currentTendance);
            this.setState({
                currentTendance : currentTendance,
                name:name
            });
            this.setHeader();
            this.getBookmark();
            this._getPosts();
        });
    }


    getName(item){
        if(this.type === "contact"){
           return item.firstname+' '+item.lastname;
        }else if(this.type === 'entity'){
            return item.name;
        }else{
	    return item.item;
        }
    }

    setHeader(){
        this.props.navigation.setOptions({
            headerTitle : ()=> {
	      return <HeaderTitreSousTitre
		name={this.state.name}
		nbArticle={this.state.currentTendance.total_counts}
		icon={
		  this.type == "theme" &&
		  this.state.currentTendance.confidential &&
		  <ConfidentialPicto style={{width: 18, height: 18, marginLeft: 4, marginTop: 1}} isHeader={true} />
		}
	      />
	    },
            headerLeft : ()=><TouchableOpacity onPress={this.props.navigation.goBack}>
                <Image resizeMode={"contain"} style={{width:20,marginLeft:10,height: 20, flex: 1}} source={this.props.theme.pictos.chevronGaucheMediumPicto.light} />
            </TouchableOpacity>
        });
    }

    getBookmark(){
        getBookmark().then(data=>{
            this.state.bookmark = data
        });
    }

    refresh(){
        this.setState({
            posts:[]
        })
    }

    _deconnexion(){
        const action = {'type': 'SIGN_OUT', 'value': ""};
        this.props.dispatch(action);
    }

    _getPosts(){
        let contact = [];
        let Entity = [];
        let theme = [];

        if(this.type === "contact"){
            contact.push(parseInt(this.id));
        }else if(this.type === 'entity'){
            Entity.push(parseInt(this.id));
        }else{
            theme.push(parseInt(this.id));
        }
        customFeed(this.state.cursor,contact,Entity,theme).then(data=>{
            let d = this.uniqueArray(this.state.posts,data.data);
            let posts = this.state.posts.concat(d) ;

            this.setState({
                cursor: data.cursor,
                posts : posts,
            });
        });
    }

    uniqueArray(arr1,arr2){
        let ids  = arr1.map((item)=>{return item.id});
        return  arr2.filter((item) =>{return !ids.includes(item.id);});
    }

    render() {
        return <PostList bookmark={this.state.bookmark} loadMore={this._getPosts}
                         refNavigation={this.props.navigation} route={this.props.route}
                         isRefresh={this.state.isRefresh} refresh={this.refresh}  data={this.state.posts} />
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer,timeParution:state.tendanceReducer.timeParution};
}

export default compose(withTranslation(),connect(mapStateToProps))(TendanceFeedScreen);
